import React from 'react';
import { Table, Tag, Button, Tooltip, Space } from 'antd';
import { UserAddOutlined, WhatsAppOutlined, TeamOutlined } from '@ant-design/icons';
import { OrganizationSummary } from '../../interfaces/orgManagement';
import "../../assets/css/tablesShadow.css"

interface OrgListTableProps {
    orgs: OrganizationSummary[];
    loading: boolean;
    onAddUser: (org: OrganizationSummary) => void;
    onViewWaba: (org: OrganizationSummary) => void;
    onViewUsers: (org: OrganizationSummary) => void;
}

const OrgListTable: React.FC<OrgListTableProps> = ({
    orgs,
    loading,
    onAddUser,
    onViewWaba,
    onViewUsers,
}) => {
    const columns = [
        {
            title: 'Account Name',
            dataIndex: 'orgName',
            key: 'orgName',
            render: (text: string) => <span className="font-medium">{text}</span>,
        },
        {
            title: 'Account ID',
            dataIndex: 'orgId',
            key: 'orgId',
            render: (text: string) => <span className="text-gray-500">{text}</span>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status: string) => {
                let color = 'green';
                if (status === 'inactive') color = 'red';
                return (
                    <Tag color={color}>
                        {status.toUpperCase()}
                    </Tag>
                );
            },
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (date: string) => date ? new Date(date).toLocaleDateString() : '-',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_: any, record: OrganizationSummary) => (
                <Space>
                    <Tooltip title="View WABA Accounts">
                        <Button
                            type="text"
                            icon={<WhatsAppOutlined />}
                            onClick={() => onViewWaba(record)}
                        />
                    </Tooltip>
                    <Tooltip title="View Assigned Users">
                        <Button
                            type="text"
                            icon={<TeamOutlined />}
                            onClick={() => onViewUsers(record)}
                        />
                    </Tooltip>
                    <Tooltip title="Grant Access to User">
                        <Button
                            type="text"
                            icon={<UserAddOutlined />}
                            onClick={() => onAddUser(record)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={orgs}
            rowKey="orgId"
            loading={loading}
            pagination={{ pageSize: 10 }}
        />
    );
};

export default OrgListTable;
